import { useMemo } from "react";
import { getTimezoneOffset } from "date-fns-tz";
import { convertToLocalTime } from "date-fns-timezone";
import { startOfDay, addHours } from "date-fns";
export default (function (timeZone) {
    return useMemo(function () {
        if (timeZone === "")
            return startOfDay(new Date());
        // Get computer TZ
        var userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // calc the hours that the account and the user are off from GMT. divide b/c ms are returned
        var accountOffset = timeZone && getTimezoneOffset(timeZone) / 3600000;
        var userOffset = timeZone && getTimezoneOffset(userTz) / 3600000;
        // find what the difference between the two is
        // if the user is west of account, this may be a negative number. this is fine.
        var offsetDiff = accountOffset
            ? Number(userOffset) - Number(accountOffset)
            : 0;
        // if the user isn't in the same tz as the account, this can cause user-calculated start-of-day
        // (midnight, 00:00:00) to be the previous day in a more westerly tz
        // for example, when it is midnight on Sep 28 in New York, it is 21:00:00 on Sep 27 in Los Angeles
        // this adds (or negatively adds) hours required to make start 00:00:00 in account tz.
        // user always starts with time that matches what the trucks have, not account time relative to local time
        // NOTE convertToLocalTime is used to mimic how dates are used in the application.
        // Dates are converted to local time when they are placed into url params and when those dates get passed to graphQL
        // They are only converted to timeZone when they are inside of the date select
        return addHours(startOfDay(convertToLocalTime(new Date(), { timeZone: timeZone })), offsetDiff);
    }, [timeZone]);
});
//# sourceMappingURL=useDefaultDate.js.map